// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7465616d","453":"0e2ace51","455":"3caa374d","627":"8f5279c9","653":"cd4c4b7f","738":"c14d8676","907":"55fd011f","923":"e0b0d3f3"}[chunkId] + ".chunk.js";
};